import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { BrowserRouter as Router } from "react-router-dom"; /* CHANGE TO HashRouter if deployed on static server*/
import CookiePolicy from "../components/CookiePolicy";
import CommunityGuide from "../components/CommunityGuide";
import SafetyGuide from "../components/SafetyGuide";
import ChildSafety from "../components/ChildSafety";
import TermsOfUse from "../components/TermsOfUse";
import PrivacyPolicy from "../components/PrivacyPolicy";
import Layout from "../components/Layout";
import LandingLayout from "../components/LandingLayout";
import Homepage from "../components/Homepage";

const MyRouter = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingLayout />}>
          <Route index element={<Homepage />} />
        </Route>
        <Route path="/" element={<Layout />}>
          <Route path="cookie-policy" element={<CookiePolicy />} />
          <Route path="privacy-policy" element={<PrivacyPolicy />} />
          <Route path="community-guide" element={<CommunityGuide />} />
          <Route path="safety-guide" element={<SafetyGuide />} />
          <Route path="child-safety" element={<ChildSafety />} />
          <Route path="terms-of-use" element={<TermsOfUse />} />
          <Route path="*" element={<Navigate replace to="/" />} />
        </Route>
      </Routes>
    </Router>
  );
};

export default MyRouter;
